






















import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import Button from './Button.vue';
import $ from 'jquery';
import { formatDate, getAlertColorByPriority, getDateFromDateFormatApi } from '../../core/utils';
@Component({
    components: {
        Button
    }
})
export default class AlertBadge extends Vue {
    @Prop({ default: 0 }) quantity: number;
    value: number = 0;

    get getAlertColor() {
        return getAlertColorByPriority();
    }

    @Watch('quantity')
    observableQuantity(value) {
        this.value = value;
    }
}
